import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";
import Tooltip from "@streeteasy/design-system/legacy/Tooltip";

const { TEXT_SECONDARY } = colors;
const { Caps } = typography;

export const HiddenLabel = styled.span`
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const PositionedTooltip = styled(Tooltip).attrs({
  position: "top",
  theme: "small",
  trigger: "click",
  width: "206px",
  zIndex: 1001
})`
  text-align: left;
  vertical-align: unset;
`;

export const TooltipTitle = styled(Caps)`
  margin-bottom: 10px;
`;

export const TooltipContent = styled.div`
  margin: 0 -8px -4px -8px;
  text-align: left;
`;

export const Trigger = styled.i.attrs({
  className: "fa fa-info-circle"
})`
  color: ${TEXT_SECONDARY};
  display: inline-block;
  font-size: 14px;
  position: relative;

  &:hover {
    cursor: pointer;
  }
`;
